import { useMutation } from '@apollo/client';
import React from 'react';
import AdminProvisionForm from './AdminProvisionForm';
import { gql } from '../../graphql/generated/gql';
import useNavigate from '../../utils/router/useNavigate';

const CREATE_PROVISION_MUTATION = gql(/** @complexity 2 */ `
  mutation createProvision(
    $favoritePostIds: [ID!]!
    $favoriteTopicIds: [ID!]!
    $name: String!
    $topicIds: [ID!]!
    $groupIds: [ID!]!
    $postIds: [ID!]!
    $type: ProvisionType!
    $urlEnabled: Boolean!
  ) {
    createProvision(
      name: $name
      favoritePostIds: $favoritePostIds
      favoriteTopicIds: $favoriteTopicIds
      groupIds: $groupIds
      postIds: $postIds
      topicIds: $topicIds
      type: $type
      urlEnabled: $urlEnabled
    ) {
      id
    }
  }
`);

const AdminProvisionNewView = () => {
  const navigate = useNavigate();
  const [createProvision] = useMutation(CREATE_PROVISION_MUTATION);

  return (
    <AdminProvisionForm
      onSubmit={(values) =>
        createProvision({
          variables: values,
        }).then(({ data }) => {
          const id = data?.createProvision?.id;

          if (id) {
            navigate(`/admin/provisions/${id}`);
          }
        })
      }
    />
  );
};

export default AdminProvisionNewView;
